<template>
  <div v-if="serverTime" class="pr-2 ml-2">
    <div class="text-body-2 font-weight-light text-secondary-600">UTC: {{ formatedDate }}</div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapState } from 'pinia'
  import { useSettingsStore } from '@/store/settings/settings'

  export default {
    name: 'ServerTime',
    data() {
      return {
        timestamp: '',
        interval: null
      }
    },
    computed: {
      ...mapState(useSettingsStore, ['serverTime']),
      formatedDate() {
        return moment(this.timestamp).format('MM.DD HH:mm:ss')
      }
    },
    watch: {
      serverTime: {
        immediate: true,
        handler() {
          if (this.serverTime) {
            this.timestamp = moment(this.serverTime).valueOf()
          }
        }
      }
    },
    created() {
      this.interval = setInterval(() => {
        this.timestamp = +this.timestamp + 1000
      }, 1000)
    },
    beforeUnmount() {
      clearInterval(this.interval)
    }
  }
</script>
